import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import styled from "styled-components";
import Constants from "../../AppConstants/Constants";
import Utilities from "../../Helpers/Utilities";
import { Translate } from "react-redux-i18n";
import { getOrderSummary } from "../../Store/Checkout/Actions";

const Option = styled.div`
    cursor: pointer;
    
    // Large devices (desktops, 992px and up)
    @media (min-width: 992px) {
        height: 185px;
    }
`;

const BoxedColumn = styled.div`
    .feature__body & {
        margin-bottom: 0;
        padding: 0 15px;
        background: transparent;
    }
`;

const Note = styled.p`
    .feature__body & {
        font-size: 8pt;
        font-weight: 400;
        line-height: 12pt;
        min-height: auto;
        margin-top: 5px;
    }
`;

class PaymentOption extends Component {
    constructor(props) {
        super(props);

        this.renderItems = this.renderItems.bind(this);
        this.inactive = this.inactive.bind(this);
        this.onSelect = this.onSelect.bind(this);
    }

    renderItems() {
        const { items, name } = this.props;

        return _.map(items, (item, i) => {
            // if (name === "Lease") {
            //     return (
            //         <BoxedColumn className="col-12 boxed" key={`${item.description}_${i}`}>
            //             <h5>{item.description}</h5>
            //             <div className="text-center">
            //                 <h4 style={{marginTop: 15}}>{Utilities.formatPrice(item.amount)}</h4>
            //                 <small>Estimated Monthly Payment for a 36 Month Lease:</small>
            //             </div>
            //         </BoxedColumn>
            //     );
            // }
            if (i !== items.length - 1) {
                return (
                    <div key={`${item.description}_${i}`}>
                        <div className="row">
                            <BoxedColumn className={`col-${item.size || 12} boxed`}>
                                <h5>{item.description}</h5>
                            </BoxedColumn>
                            {item.amount > 0 &&
                            <BoxedColumn className={`col-${12 - (item.size || 12)} boxed text-right`}>
                                {Utilities.formatPrice(item.amount)}
                            </BoxedColumn>
                            }
                        </div>
                        <hr/>
                    </div>
                );
            } else {
                return (
                    <div className="row" key={`${item.description}_${i}`}>
                        <BoxedColumn className="col-12 boxed">
                            <div className="row">
                                <BoxedColumn className={`col-${item.size || 12} boxed`} key={0}>
                                    <h5>{item.description}</h5>
                                </BoxedColumn>
                                <BoxedColumn className={`col-${12 - (item.size || 12)} boxed text-right`} key={1}>
                                    {Utilities.formatPrice(item.amount > 0 ? item.amount : 0)}
                                </BoxedColumn>
                            </div>
                        </BoxedColumn>
                    </div>
                );
            }
        });
    }

    active(e) {
        _.each(document.getElementsByClassName("payment-option"), el => el.classList.remove("feature--featured"));
        e.target.classList.add("feature--featured");
    }

    inactive(e) {
        if (!this.props.active) {
            e.target.classList.remove("feature--featured");
        }
    }

    onSelect() {
        const { disabled, onSelect, index, history, getOrderSummary, onOptionClick } = this.props;

        if (!disabled) {
            onSelect(index);
            getOrderSummary();

            if (onOptionClick && typeof onOptionClick === "function") {
                onOptionClick();
            } else if (index === 0) {
                setTimeout(() => {
                    history.push(Constants.ENDPOINTS.PAY_IN_FULL_CHECKOUT);
                }, 300);
            } else if (index === 1) {
                setTimeout(() => {
                    history.push(Constants.ENDPOINTS.LEASE_CHECKOUT);
                }, 300);
            }
        }
    }

    render() {
        const { active, disabled, name, cartItems, config: { RENTALS_CATEGORY_ID } } = this.props;
        // Only passing cartItems to the Lease Payment Container. So if the container has cartItems and any item in the Cart has a rental (by categoryId).
        // If Rental Exists dont show the lease box estimates, and show the message, and make it so it cant be clicked
        if(cartItems && _.find(cartItems, {categoryId: RENTALS_CATEGORY_ID})) {
            return (
                <div>
                    <h4 style={{ marginBottom: 10 }}>{this.props.name}</h4>
                    <Option className={`feature feature-5 boxed boxed--border payment-option ${name.replace(/\s+/g, '')}-box disabled`} style={{ pointerEvents: "none" }}>
                        <div className="feature__body" style={{ width: "100%" }}>
                            <div className="row justify-content-center">
                                <div className="col-xl-12">
                                    <p style={{ color: "#252525", fontWeight: "600" }}><Translate value="cart.rentalMessage" /></p>
                                </div>
                            </div>
                        </div>
                    </Option>
                </div>
            );
        } else {
            return (
                <div>
                    <h4 style={{ marginBottom: 10 }}>{this.props.name}</h4>
                    <Option className={`feature feature-5 boxed boxed--border payment-option ${name.replace(/\s+/g, '')}-box ${active ? "feature--featured" : ""} ${disabled ? "disabled" : ""}`} onMouseEnter={this.active} onMouseLeave={this.inactive} onFocus={this.active} onClick={this.onSelect} style={disabled ? { pointerEvents: "none", backgroundColor: "#eee" } : {}}>
                        <div className="feature__body" style={{ width: "100%" }}>
                            {this.renderItems()}
                            <div className="row justify-content-center">
                                <div className="col-xl-9 text-center">
                                    <Note>{this.props.note}</Note>
                                </div>
                            </div>
                        </div>
                    </Option>
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    return {
        config: state.config
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getOrderSummary: getOrderSummary
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PaymentOption));